import { render, staticRenderFns } from "./ProductModalEdit.vue?vue&type=template&id=280f4b86"
import script from "./ProductModalEdit.vue?vue&type=script&lang=js"
export * from "./ProductModalEdit.vue?vue&type=script&lang=js"
import style0 from "./ProductModalEdit.vue?vue&type=style&index=0&id=280f4b86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports